import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import NumberEasing from "react-number-easing";

import hhGaugeBackground from "../../assets/ui/help-hinder-gauge/hh-gauge-background.png";
import hhGaugeHinderInnerImage from "../../assets/ui/help-hinder-gauge/hh-gauge-hinder-inner.png";
import hhGaugeHelpInnerImage from "../../assets/ui/help-hinder-gauge/hh-gauge-help-inner.png";
import hhGaugeIndicatorImage from "../../assets/ui/help-hinder-gauge/hh-gauge-indicator.png";
import fistRedIcon from "../../assets/ui/icons/fist-red.png";
import heartGreenIcon from "../../assets/ui/icons/heart-green.png";

import "./HelpHinderGauge.scss";
import useTimers from "../../hooks/useTimers.js";
import IconButton from "../IconButton/IconButton.js";

const HelpHinderGauge = ({
  totalVotes,
  helpPercentage,
  hinderPercentage,
  vote,
  isHhVoteInProgress,
  onVote,
}) => {
  const { t } = useTranslation();
  const timers = useTimers();

  const shouldHideIndicator =
    helpPercentage >= 0.95 || hinderPercentage >= 0.95;
  const numberEasingSpeed =
    timers?.helpHinder?.hhUpdateInterval * 1000 * 0.9 || 5500;

  return (
    <React.Fragment>
      <div className="hh-gauge-container">
        <IconButton
          icon={heartGreenIcon}
          isActive={vote === "help"}
          onClick={() => onVote("help")}
        />
        <div className="hh-gauge">
          <div className="hh-gauge__inner">
            <div className="hh-gauge__track">
              <img
                className="hh-gauge__indicator"
                src={hhGaugeIndicatorImage}
                alt=""
                style={{
                  left: `calc(${helpPercentage * 100}% - 3px)`,
                  opacity: shouldHideIndicator ? 0 : 1,
                }}
              />
            </div>
            {/*<img className="hh-gauge__marker" src={hhGaugeMarkerImage} alt="" />*/}
            <img
              className="hh-gauge__image"
              src={hhGaugeHelpInnerImage}
              alt=""
            />
            <img
              className="hh-gauge__image"
              src={hhGaugeHinderInnerImage}
              alt=""
              style={{
                clipPath: `inset(0px 0px 0px ${(1 - hinderPercentage) * 100}%)`,
              }}
            />
            <img
              className="hh-gauge__background-image"
              src={hhGaugeBackground}
              alt=""
            />
          </div>
          <div
            className={classNames("hh-gauge__vote-count", {
              "hh-gauge__vote-count--help": helpPercentage > hinderPercentage,
              "hh-gauge__vote-count--hinder": helpPercentage < hinderPercentage,
            })}
          >
            <NumberEasing
              value={totalVotes}
              speed={numberEasingSpeed}
              decimals={0}
              ease="linear"
              customFunctionRender={(value) =>
                t("features.helpOrHinder.hhVotingFlyout.voteCount", {
                  amount: Math.ceil(value),
                })
              }
            />
          </div>
        </div>
        <IconButton
          icon={fistRedIcon}
          disabled={isHhVoteInProgress}
          isActive={vote === "hinder"}
          onClick={() => onVote("hinder")}
        />
      </div>
    </React.Fragment>
  );
};

export default HelpHinderGauge;
